import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import { useRef, useMemo } from 'react';
import { isBoolean, uniqueId } from '@remirror/core';
import { defaultAbsolutePosition } from '@remirror/extension-positioner';
import { useMultiPositioner } from '../../use-multi-positioner/dist/remirror-react-hooks-use-multi-positioner.browser.esm.js';
import '@babel/runtime/helpers/createForOfIteratorHelper';
import '@babel/runtime/helpers/slicedToArray';
import 'use-isomorphic-layout-effect';
import 'use-previous';
import '@remirror/react-core';

function usePositioner(positioner, activeOrDeps) {
  var deps = activeOrDeps == null || isBoolean(activeOrDeps) ? [positioner] : activeOrDeps;
  var isActive = isBoolean(activeOrDeps) ? activeOrDeps : true;
  var key = useRef(uniqueId());
  var positions = useMultiPositioner(positioner, deps);
  var position = positions[0];
  return useMemo(() => {
    if (position && isActive) {
      return _objectSpread(_objectSpread({}, position), {}, {
        active: true
      });
    }

    return _objectSpread(_objectSpread({}, defaultAbsolutePosition), {}, {
      active: false,
      key: key.current
    });
  }, [isActive, position]);
}

export { usePositioner };
